/**
 * Keeps the header flush below a sticky announcement bar by setting
 * --announcement-sticky-offset to the measured bar height (px).
 */
(function () {
  const OFFSET_VAR = '--announcement-sticky-offset';

  function setOffset() {
    const section = document.querySelector('.shopify-section.announcement-bar-section');
    let px = '0px';
    if (section) {
      const h = Math.round(section.getBoundingClientRect().height);
      if (h > 0) px = `${h}px`;
    }
    document.documentElement.style.setProperty(OFFSET_VAR, px);
  }

  function scheduleUpdate() {
    window.requestAnimationFrame(setOffset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setOffset);
  } else {
    setOffset();
  }

  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('shopify:section:load', setOffset);
  document.addEventListener('shopify:section:unload', setOffset);
})();
